module.exports = __webpack_public_path__ + "../resources/img/bg_pv2_01.4d3ae2d4.png";